import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragOverlay,
} from '@dnd-kit/core'
import {
  SortableContext,
  verticalListSortingStrategy,
  arrayMove,
} from '@dnd-kit/sortable'
import { restrictToVerticalAxis } from '@dnd-kit/modifiers'
import { useState } from 'react'
import CarouselItem from './CarouselItem'

interface Props {
  items: any[]
  getImageSrc: (src: string) => string
  setItems:any
}

export default function CarouselList({
  items,
  getImageSrc,
  setItems,
}: Props) {
  const [activeItem, setActiveItem] = useState<any>(null)

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // scroll + drag conflict avoid
      },
    })
  )

  
  const moveItem = (from: number, to: number) => {
    if (to < 0 || to >= items.length) return
    setItems((prev) => arrayMove(prev, from, to))
  }


  return (
    <DndContext
      sensors={sensors}
      collisionDetection={closestCenter}
      modifiers={[restrictToVerticalAxis]}
      autoScroll={{ enabled: true }}
      onDragStart={(event) => {
        setActiveItem(
          items.find((i) => i === event.active.id)
        )
      }}
      onDragEnd={(event) => {
        const { active, over } = event
        setActiveItem(null)

        if (over && active.id !== over.id) {
          setItems((prev) => {
            const oldIndex = prev.findIndex(
              (i) => i.id === active.id
            )
            const newIndex = prev.findIndex(
              (i) => i.id === over.id
            )
            return arrayMove(prev, oldIndex, newIndex)
          })
        }
      }}
      onDragCancel={() => setActiveItem(null)}
    >
      <SortableContext
        items={items.map((i) => i.id)}
        strategy={verticalListSortingStrategy}
      >
        {/* 👇 only 5 visible */}
        <div className="space-y-4 max-h-[400px] overflow-y-auto pr-2">
          {items.map((item, index) => (
            <CarouselItem
             key={item.id}
              item={item}
              index={index}
              total={items.length}
              onMoveUp={() => moveItem(index, index - 1)}
              onMoveDown={() => moveItem(index, index + 1)}
              onDelete={() =>
                setItems((prev) => prev.filter(i => i.id !== item.id))
              }
            >
              {/* 👇 Tumhara existing UI */}
              <div className="flex items-center gap-2">
                
                <div className="bg-gray-900 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm font-bold flex-shrink-0">
                    {index + 1}
                </div>
                <img
                  src={getImageSrc(item.thumbnail)}
                  alt="Thumbnail"
                  className="w-15 h-12 object-cover rounded border"
                />
                <div>
                  <p className="text-sm font-medium text-gray-700 dark:text-gray-200">
                    {item.name}
                  </p>
                  <p className="text-xs text-gray-500">
                    ID: {item.redirectionId || item.id}
                  </p>
                  <p className="text-xs text-gray-500">
                    {item.type}
                  </p>
                </div>
              </div>
            </CarouselItem>
          ))}
        </div>
      </SortableContext>

      {/* 🔥 Drag Ghost */}
      <DragOverlay>
        {activeItem ? (
          <div className="p-3 rounded-lg bg-white shadow-xl border w-[250px]">
            <p className="text-sm font-medium">
              {activeItem.name}
            </p>
            <p className="text-xs text-gray-500">
              {activeItem.type}
            </p>
          </div>
        ) : null}
      </DragOverlay>
    </DndContext>
  )
}
